import { createBrowserRouter } from 'react-router-dom';

import { routeConfig } from './routeConfig';

export const router: ReturnType<typeof createBrowserRouter> =
  createBrowserRouter(routeConfig, {
    basename: import.meta.env.VITE_ROUTER_BASENAME || undefined,
  });
